// Prod_US backend calls. Three new endpoints (Prod_US_Backend-v1.0.md); everything else
// reuses existing calls: person create = POST /seniors (mmtUserList/mmtApi.js addPatient),
// uploads = asset token -> signed-URL PUT -> events (measurementBackgroundUpload.js),
// report = the existing report endpoints. All calls send the Firebase ID token as Bearer.
import axios from "axios";
import { APP_URL } from "../../services/serviceConstants";
import { getIdToken } from "./firebasePhoneAuth";

const api = axios.create({ baseURL: APP_URL });

const authHeaders = async () => ({
  headers: {
    Authorization: `Bearer ${await getIdToken()}`,
    Accept: "application/json",
    "Accept-Language": "en-US",
  },
});

const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

/*
 * GET /v1/prod-us/me
 * First call after sign-in creates the app user with 2 credits (backend).
 * -> {
 *   app_user: { id, phone, credits, customer_type: "prod_us", checked_for, consent_confirmed_at },
 *   person:   null | <the same row GET /v3/seniors returns: id, seniorId, first_name, last_name,
 *              name, test_person_id, seniorlife_id, gender, age, height_cm, birth_year, birth_month>,
 *   check:    { status: "none" | "uploading" | "analyzing" | "ready" | "failed",
 *               assessment_id, checked_at, report_ready_at }
 * }
 */
export const getProdUsMe = async () =>
  unwrap(await api.get("/v1/prod-us/me", await authHeaders()));

// PATCH /v1/prod-us/me  { checked_for: "self" | "other", consent_confirmed: true }
export const saveWhoIsChecked = async (checkedFor) =>
  unwrap(
    await api.patch(
      "/v1/prod-us/me",
      { checked_for: checkedFor, consent_confirmed: true },
      await authHeaders(),
    ),
  );

// PUT /v4/seniors/:id - the person's own fields; the backend keeps the IDs as assigned.
export const updateProdUsPerson = async (personId, fields) =>
  unwrap(
    await api.put(
      `/v4/seniors/${encodeURIComponent(personId)}`,
      {
        data: Object.entries(fields).map(([uniqueId, value]) => ({
          uniqueId,
          value,
        })),
      },
      await authHeaders(),
    ),
  );

// DELETE /v1/prod-us/me  - deletes the app user, the person, results and stored stills.
export const deleteProdUsMe = async () =>
  unwrap(await api.delete("/v1/prod-us/me", await authHeaders()));
